export default {
  leaveDialog: {
    pageMessage:
      "Wenn Sie diese Seite verlassen, gehen alle Änderungen verloren!\nDiese sind danach unwiderrufbar!",
    dialogMessage:
      "Wenn Sie diesen Dialog verlassen, gehen alle Änderungen verloren!\nDiese sind danach unwiderrufbar!",
    screenMessage:
      "Wenn Sie diese Ansicht verlassen, gehen alle Änderungen verloren!\nDiese sind danach unwiderrufbar!",
    confirm: "Fertig bearbeiten",
    cancelPage: "Seite verlassen",
    cancelDialog: "Dialog verlassen",
    cancelScreen: "Ansicht verlassen",
  },
  updateDialog: {
    title: "Update verfügbar",
    optionalUpdateMessage:
      "Ein neues Update ist verfügbar. Soll es jetzt installiert werden?",
    optionalInstallLabel: "Installieren",
    mandatoryUpdateMessage:
      "Ein neues Update ist verfügbar. Dieses wird jetzt installiert.",
  },
} as const
